import React, { useState } from 'react';
import { FormControl, InputLabel, OutlinedInput, InputAdornment, TextField, IconButton, Select, MenuItem, SelectChangeEvent, Modal, Typography } from '@mui/material';
import "./styles.scss";
import Grid from "@mui/material/Grid2";
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

interface Props {
  label: string;
  value: string | null;
  options: { value: string | number; label: string, description: string }[];
  onChange: (e: any) => void;
  onClear?: () => void;
}


export const SelectLeftLabel = ({ label, value, options, onChange, onClear }: Props) => {

  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

  const CustomArrowIcon = (props: any) => (
    <ArrowDropUpIcon
      {...props}
      sx={{ color: '#0a2d5a !important', fontSize: 42 }} // Change color and size here
    />
  );

  return (
    <>
      <Modal open={showInfoModal} onClose={() => setShowInfoModal(false)}>
        <Grid className="modal-description">
          <Grid className="description_title_header">
            <Grid className="title_header">
              Descripcion de Las Opciones
            </Grid>
            <IconButton
              size="small"
              color="warning"
              onClick={() => { setShowInfoModal(false) }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid className="description_content">
            {options.map((option) => (
              <Grid key={option.value} className="description-option-content">
                <span className="description_bullet">•</span>
                <strong>{option.label}</strong>:
                <span className="description_text">{option.description}</span>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Modal>
      <Grid className="select-form-control">

        <InputLabel className="select-label-left">{label}
          <IconButton
            size="small"
            sx={{ color: '#f7f8f8ff !important', fontSize: 42 }}
            onClick={() => { setShowInfoModal(true) }}
          >
            <InfoIcon />
          </IconButton></InputLabel>
        <Select
          labelId="tipo-busqueda-label"
          value={value}
          onChange={(e) => onChange(e)}
          size='small'
          className="operations-select"
          IconComponent={CustomArrowIcon}
        >
          <MenuItem key="default-0" value="" disabled>
            <em>Seleccione una opción</em>
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {onClear && value && (
          <IconButton
            size="small"
            color="error"
            onClick={() => onClear()}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Grid>
    </>
  )
}